import { accessCriteria } from '../util/authorization/index';
import { authRoles } from './roleGroups';

const DOCUMENT_TITLE = 'Tax Adjustments';

export const TARoutes = [
  {
    path: '/tax/adjustments',
    name: 'Tax-Adjustments',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/TaxRollAdjustments.vue'),
    children: [
      {
        path: 'adjustmentssearch',
        name: 'Tax - Tax Roll Adjustments',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/TaxRollAdjustments/TaxRollAdjustmentsSearch.vue'),
      },
      {
        path: 'assessorupdate',
        name: 'Tax - Assessor Update',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/TaxRollAdjustments/AssessorUpdate.vue'),
      },
    ],
  },
];

TARoutes.forEach((element, index) => {
  TARoutes[index].beforeEnter = async (to, from, next) => {
    await accessCriteria([...authRoles.TaxRead, ...authRoles.AjustmentAuth], next);
  };
});

export default TARoutes;
